export default __webpack_public_path__ + "static/media/Darkchill.214dc55f.jpg";